<script>
  import Card from "../Card.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import CardBody from "../CardBody.svelte";

  export let url = "";
  export let title;
  export let description = "";
  export let fullWidth = false;

  export let imageComponent;
  export let resizeParams;
  export let widthsAt = {};

  let imageSize = fullWidth ? "w-108 md:w-178" : "w-108 md:w-144";
</script>

<Card {url} class="group w-full flex flex-row items-center p-0" let:hasFocus>
  <CardBody
    {title}
    {description}
    {url}
    bodyClass="flex flex-col gap-16 items-start group-hover:underline pl-16 md:pl-24 order-2"
    titleClass="heading-card font-normal leading-6.5 focus:!bg-none focus:outline-none group-focus:!no-underline active:text-black"
    horizontal
  />

  <!-- image -->
  {#if imageComponent}
    <ImageComponent
      containerClass="h-full overflow-hidden border border-transparent group-focus:border-black group-focus:shadow-card group-active:shadow-card {imageSize} {hasFocus &&
        'shadow-card'}"
      elementClass="w-full aspect-square object-cover"
      data={imageComponent}
      displayCaption={false}
      responsive
      {resizeParams}
      {...widthsAt}
    />
  {/if}
</Card>
